import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import cl from "classnames";
import './Input.scss';

type InputProps = {
    tooltip?: string | {
        content: string;
        placement?: 'top' | 'bottom' | 'left' | 'right';
    };
    isInvalid?: boolean;
    isValid?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

interface InputComponent extends React.ForwardRefExoticComponent<InputProps & React.RefAttributes<HTMLInputElement>> {
    Container: React.FC<{ children: React.ReactNode }>;
}

const Input = React.forwardRef(
    (
        {
            tooltip,
            className,
            isInvalid = false,
            isValid = false,
            ...props
        }: InputProps,
        ref: React.Ref<HTMLInputElement>
    ) => {
        const tooltipComponent = !tooltip ? null : (
            <Tooltip id="tooltip">
                {typeof tooltip === 'string' ? tooltip : tooltip.content}
            </Tooltip>
        );
        const placement = tooltip && typeof tooltip !== 'string' ? tooltip.placement : 'right';
        return (
            <div className="ew-input-wrapper">
                <input
                    ref={ref}
                    className={cl('ew-input', className, {
                        ['ew-input--error']: isInvalid,
                        ['ew-input--valid']: isValid,
                    })}
                    {...props}
                />
                {tooltipComponent && (
                    <div className="ew-input-hint">
                        <OverlayTrigger placement={placement} overlay={tooltipComponent}>
                            <Icon icon={faInfoCircle}/>
                        </OverlayTrigger>
                    </div>
                )}
            </div>
        );
    }
) as InputComponent;

Input.Container = ({ children }: { children: React.ReactNode }) => (
    <div className="ew-input-container">{children}</div>
);

export default Input;